module.exports = __webpack_public_path__ + "static/short01-a6fea0cd3fd325efe5c0cf9aafb20acb.jpg";